import { createSlice } from '@reduxjs/toolkit'


export const counterSlice = createSlice({
  name: 'counter',
  initialState: {
    value: 0,
    step: 1
  },
  reducers: {
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += state.step
    },
    decrement: state => {
      state.value -= state.step
    },
    increaseStep: state => {
      state.step += 1
    },
    decreaseStep: state => {
      if(state.step - 1 < 1) return

      state.step -= 1
    }
  }
})

export const { 
  increment, 
  decrement,
  
  increaseStep,
  decreaseStep

} = counterSlice.actions
